module.exports = __webpack_public_path__ + "img/团订客户.16552d11.png";